import React from "react";

const projectorRoutes = [
  {
    path: "/projector",
    lazy: async () => {
      const [outletMod, errorMod] = await Promise.all([
        // @ts-ignore
        import("../../OutletOnly"),
        import("views/ErrorPage"),
      ]);
      const OutletOnly = outletMod.default;
      const ErrorPage = errorMod.default;
      return { Component: OutletOnly, ErrorBoundary: ErrorPage };
    },
    children: [
      {
        index: true,
        lazy: async () => {
          const mod = await import("views/projector");
          const ProjectorLanding = mod.ProjectorLanding;
          return { Component: ProjectorLanding };
        },
      },
      {
        path: "projector-view/:friendlyId",
        lazy: async () => {
          const mod = await import("views/projector/projector-view-mode");
          const ProjectorViewMode = mod.ProjectorViewMode;
          return { Component: ProjectorViewMode };
        },
      },
    ],
  },
];

export default projectorRoutes;
